import React from "react";
import { Form, Col } from "react-bootstrap";

const defaultTemplate = function(value) {
 
  return (
    <Col style={{maxWidth:value.label=="Commissioned"?"28%":null,marginRight:value.label=="Under Construction"==true?"-9%":null }}>
      <Form.Check>
        <Form.Check.Input {...value} />
        <Form.Check.Label>{value.label}</Form.Check.Label>
      </Form.Check>
    </Col>
  );
};

export function EditNonpmg(props) {
  const {
    options = [],
    keyName = "",
    type = "radio",
    name = "",
    events = {},
    Template = defaultTemplate,
    projectImplementationStartState
  } = props;
  return (
    <>
      <Form.Row as={Col} key={type} data-key={keyName} {...events}>
        {options.map((value, index) => (
          <Template {...value} data-key={keyName} type={type} name={name} />
        ))}
      </Form.Row>
    </>
  );
}
